
import Vue from 'vue';
import {Component} from 'vue-property-decorator';

@Component
export default class EditAccessPermissionsConstantsMixin extends Vue {

  get tabs() {
    return [
      'campaigns',
      'offers',
      'landings',
      'flows',
      'trafficSources',
      'affiliateNetworks',
    ];
  }

  getDefaultUserAlc(): {
    [type: string]: any
  } {
    return {
      accessToExistingItems: 'fullAccess',
      hideProfit:false,
      showConversions:false,
      canCreate: {
        affiliateNetworks: true,
        campaigns: true,
        flows: true,
        landings: true,
        offers: true,
        trafficSources: true
      },
      acl:{
        campaign: {
          '*': 'fullAccess'
        },
        trafficSource: {
          '*': 'fullAccess'
        },
        landing: {
          '*': 'fullAccess'
        },
        offer: {
          '*': 'fullAccess'
        },
        flow: {
          '*': 'fullAccess'
        },
        affiliateNetwork: {
          '*': 'fullAccess'
        },
      }
    }
  }

  getDefaultItemsRelationsObject() {
    return {
      campaigns: {
        '*': {
          uses: {
            flow: '*',
            landings: ['*'],
            offers: ['*'],
            trafficSource: '*'
          }
        }
      },
      trafficSources: {
        '*': {
          depends: {
            campaigns: ['*'],
          }
        }
      },
      landings: {
        '*': {
          depends: {
            campaigns: ['*'],
            flows: ['*'],
          }
        }
      },
      offers: {
        '*': {
          uses: {
            affiliateNetwork: '*'
          },
          depends: {
            campaigns: ['*'],
            flows: ['*'],
          }
        }
      },
      flows: {
        '*': {
          uses: {
            landings: ['*'],
            offers: ['*']
          },
          depends: {
            campaigns: ['*'],
          }
        }
      },
      affiliateNetworks: {
        '*': {
          depends: {
            offers: ['*'],
          }
        }
      }
    }
  }

  getDefaultPagination() {
    return {
      rowsPerPage: 5,
      page: 1,
      visible: 5
    };
  }

  get tabsSettings(): { single: string, plural: string}[] {
    return [
      {
        single: 'campaign',
        plural: 'campaigns'
      },
      {
        single: 'trafficSource',
        plural: 'trafficSources'
      },
      {
        single: 'flow',
        plural: 'flows'
      },
      {
        single: 'landing',
        plural: 'landings'
      },
      {
        single: 'offer',
        plural: 'offers'
      },
      {
        single: 'affiliateNetwork',
        plural: 'affiliateNetworks'
      },
    ];
  }

  get tabs_map() {
    return this.tabsSettings.reduce((result, item, index, array) => {
      result[item.plural] = item.single;
      return result;
    }, {} as {[type: string]: string})
  }

  get i18n() : {
    [type: string]: {
      header: string;
      title: string;
      icon: string;
    }
  } {
    return {
      campaigns: {
        header: this.t('All campaigns'),
        title:  this.t('Campaigns'),
        icon:'fa-bullseye-arrow'
      },
      trafficSources: {
        header: this.t('All traffic sources'),
        title: this.t('Traffic sources'),
        icon:'fa-globe'
      },
      flows: {
        header: this.t('All flows'),
        title: this.t('Flows'),
        icon:'fa-random'
      },
      landings: {
        header: this.t('All Landings'),
        title: this.t('Landings'),
        icon:'fa-browser'
      },
      offers: {
        header: this.t('All Offers'),
        title: this.t('Offers'),
        icon:'fa-badge-dollar'
      },
      affiliateNetworks: {
        header: this.t('All affiliate networks'),
        title: this.t('Affiliate networks'),
        icon:'fa-users-class'
      },
    };
  } 

  get headers() {
    return [
      {
        text: 'name',
        align: 'left',
        value: 'name',
        sortable: false
      },
      {
        text: 'id',
        align: 'right',
        value: 'id',
        sortable: false,
        width: '200px'
      },
    ]
  }
  
  get access(){
    return Object.values(this.accessObj)
  }

  accessObj = {
    inherit:{
      text: this.t('Inherit'),
      value: 'inherit',
      priority: 0
    },
    deny:{
      text: this.t('Access denied'),
      value: 'deny',
      priority: 1
    },
    reportsOnly:{
      text: this.t('Reports only'),
      value: 'reportsOnly',
      priority: 2
    },
    readOnly:{
      text: this.t('Read only'),
      value: 'readOnly',
      priority: 3
    },
    fullAccess:{
      text: this.t('Full access'),
      value: 'fullAccess',
      priority: 4
    }
  }

  get accessAll() {
    return this.access.filter((item) => item.value !== 'inherit')
  }
}
